/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * The callbacks themselves, for the modal a cell opens.
 */
export const CallbacksListQueryParams = zod.object({
  "car": zod.string().uuid().optional().describe('One elevator.'),
  "car_limit": zod.number().optional().describe('Return at most this many elevators. Defaults to all of them.'),
  "car_offset": zod.number().optional().describe('Skip this many elevators, in name order.'),
  "contract": zod.string().uuid().optional().describe('Every elevator on one contract, across its properties.'),
  "end_date": zod.string().date().optional().describe('Defaults to the last day of the current month.'),
  "property": zod.string().uuid().optional().describe('Every elevator at one property.'),
  "start_date": zod.string().date().optional().describe('Defaults to the first of the month eleven months back.')
})

export const CallbacksListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "number": zod.string(),
  "entryType": zod.enum(['regular', 'emergency', 'deferred']).describe('\* `regular` - Regular Callback\n\* `emergency` - Emergency\/Entrapment\n\* `deferred` - Deferred Callback'),
  "carId": zod.string().uuid(),
  "carName": zod.string(),
  "calledOn": zod.string().date(),
  "equipmentFailure": zod.boolean().nullable(),
  "problemType": zod.string()
}).strict().describe('One callback behind a cell, enough to name it and open it.')
export const CallbacksListResponse = zod.array(CallbacksListResponseItem)

/**
 * One row per elevator, with a cell per month.
 */
export const CallbacksSummaryRetrieveQueryParams = zod.object({
  "car": zod.string().uuid().optional().describe('One elevator.'),
  "car_limit": zod.number().optional().describe('Return at most this many elevators. Defaults to all of them.'),
  "car_offset": zod.number().optional().describe('Skip this many elevators, in name order.'),
  "contract": zod.string().uuid().optional().describe('Every elevator on one contract, across its properties.'),
  "end_date": zod.string().date().optional().describe('Defaults to the last day of the current month.'),
  "property": zod.string().uuid().optional().describe('Every elevator at one property.'),
  "start_date": zod.string().date().optional().describe('Defaults to the first of the month eleven months back.')
})

export const CallbacksSummaryRetrieveResponse = zod.object({
  "window": zod.object({
  "startDate": zod.string().date(),
  "endDate": zod.string().date()
}).strict(),
  "cars": zod.array(zod.object({
  "carId": zod.string().uuid(),
  "carName": zod.string(),
  "propertyId": zod.string().uuid().nullable(),
  "propertyName": zod.string(),
  "serviceProviderName": zod.string(),
  "months": zod.array(zod.object({
  "monthStart": zod.string().date(),
  "callbacks": zod.number().describe('Regular, deferred and emergency together. Zero is a real figure, not a gap: nobody owes us a callback.'),
  "emergency": zod.number().describe('How many of `callbacks` were entrapments.')
}).strict().describe('One cell of the grid: how often this elevator was called in that month.')),
  "callbacks": zod.number(),
  "emergency": zod.number(),
  "annualizedRate": zod.number().describe('The window\'s callbacks scaled to a full year, so a part-year window can be read against the contract\'s annual target.'),
  "emergencyAnnualizedRate": zod.number().describe('The entrapments alone, scaled the same way.'),
  "targetRate": zod.number().describe('Callbacks per elevator per year the contract allows. An elevator with no live contract falls back to the house default.'),
  "emergencyTargetRate": zod.number().describe('Entrapments per elevator per year the contract allows. Set separately from the callback target, and judged separately.'),
  "overTarget": zod.boolean().describe('Exactly on target is meeting it, matching the tick the elevator page draws.'),
  "overEmergencyTarget": zod.boolean().describe('The same test against the entrapment target.')
}).strict().describe('One elevator\'s callbacks over the window.')),
  "totalCars": zod.number().describe('Elevators in scope across every page.')
}).strict().describe('One row per elevator, with the window the caller should draw them in.')

